import { Observable } from 'rxjs';

import { put } from 'epics/ajax';

import { contextPath } from 'util/history';

import type { LoginAnnouncementsUpdateRequestPayload } from './types';

export const updateLoginAnnouncements = (payload: LoginAnnouncementsUpdateRequestPayload, context = contextPath) => {
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/signInPageAnnouncements`;
    return put(uri, payload, { 'Content-Type': 'application/json' })
        .map(({ response }) => response)
        .catch((e) => Observable.throw(e));
};
